import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, {tableCellClasses} from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {styled} from "@mui/material/styles";
import {IOrderDetail} from "../models/IOrderDetail";
import {Localization} from "../../../localization/Localization";

function createData(
	name: string,
	value: string | null | undefined,
) {
	if (!value)
		value = "";
	return {name, value};
}

const StyledTableCell = styled(TableCell)(({theme}) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: theme.palette.common.black,
		color: theme.palette.common.white,
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 14,
	},
}));

const StyledTableRow = styled(TableRow)(({theme}) => ({
	"&:nth-of-type(odd)": {
		backgroundColor: theme.palette.action.hover,
	},
	// hide last border
	"&:last-child td, &:last-child th": {
		border: 0,
	},
}));

export function GeneralData(props: { order: IOrderDetail }) {
	if (!props.order.policyId)
		return (<div></div>);
	const order = props.order;
	const rows = [
		createData("ApplicationNumber", order.policyId),
		createData("ApiUser", order.apiClientName),
		createData("TransactionDate", Localization.formatDateTime(order.transactionDate)),
		createData("PackageId", order.package?.customProperties?.externalId),
		createData("ProviderName", order.package?.companyNameDescription),
		createData("PackageTitle", order.package?.productDescription),
		createData("ProductCode", order.package?.customProperties?.productKrn),
		createData("PaymentOption", order.paymentDetails?.paymentMethod?.toString()),
		createData("PaymentPeriod", order.paymentDetails?.paymentTermInMonths?.toString()),
		createData("StartDate", Localization.formatDate(order.package?.effectiveDate)),
		createData("IBAN", order.paymentDetails?.collectionAccountIban)
	];
	return (
		<TableContainer component={Paper}>
			<Table sx={{minWidth: 650}} size="small" aria-label="Data">
				<TableBody>
					{rows.map((row) => (
						<StyledTableRow
							key={row.name}
						>
							<StyledTableCell component="th" scope="row">
								{row.name}
							</StyledTableCell>
							<StyledTableCell align="right">{row.value}</StyledTableCell>
						</StyledTableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
	
}
